import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
} from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authToken = this.authService.getToken();
    const authRequest = request.clone({
      headers: request.headers
        .set('Authorization', 'Bearer ' + authToken)
        .set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache')
    });
    return next.handle(authRequest);
  }
}
